import React from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getGameById } from "../api/game";
import { useGameTexts } from "../hooks/useGameTexts";
import logoMedical from "../assets/logo-medical.png";
import martina from "../assets/martina.png";
import PatientAvatar from "../components/PatientAvatar";
import { SERVER_URL } from "../api";
import { ROUTES } from "../utils/constants";
import { updateTimer } from "../utils/helpers";
import { modalStartGame, modalWait } from "../utils/logger";

function buildClockImageUrl(value) {
	if (!value || typeof value !== "string") return undefined;
	const path = value.trim().replace(/^\//, "");
	if (!path) return undefined;
	return path.startsWith("http") ? path : `${SERVER_URL.replace(/\/$/, "")}/${path}`;
}

function Context({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const prevState = useLocation();

	const group = useSelector((state) => state?.group);
	const game = useSelector((state) => state?.game);
	const { texts, ready } = useGameTexts(group?.game);
	const durationMinutes = typeof game === "object" && game?.durationMinutes != null && game.durationMinutes >= 1 ? game.durationMinutes : 45;

	const introText = texts["context.intro"] ?? "";
	const startGameModalHtml = texts["context.startGameModal"] ?? null;
	const clockImageUrl = buildClockImageUrl(texts["context.clock.image"]);
	const clockOptions = clockImageUrl ? { clockImageUrl } : {};

	const handleStartGame = () => {
		let time = group?.time ? parseInt(group?.time) : 0;
		updateTimer(time);
	};

	return (
		<div className="h-100">
			<div className="container-fluid bg-internas">
				<div style={{ paddingTop: "6vh", paddingLeft: "6vh" }}>
					<img width={240} src={logoMedical} />
				</div>
				<div className="row d-flex justify-content-center align-items-center mt-5 pt-5" style={{ minHeight: "50vh" }}>
					<div className="col-9">
						<div className="ms-5 ps-4 d-flex align-items-center">
							{!ready ? (
								<div className="txtWhite">Cargando...</div>
							) : (
								<>
									<PatientAvatar gameId={group?.game} defaultSrc={martina} width={350} />
									<div
										className="ms-4 txtWhite txt20 text-center"
										style={{ lineHeight: "30px" }}
										dangerouslySetInnerHTML={{
											__html: introText || "",
										}}
									/>
								</>
							)}
						</div>
					</div>
				</div>
			</div>
			<div
				className="container"
				style={{
					position: "absolute",
					bottom: "8vh",
				}}
			>
				<div className="d-flex justify-content-end">
					<div
						className="btn-main"
						onClick={(e) => {
							modalStartGame(startGameModalHtml || undefined, durationMinutes, clockOptions).then((res) => {
								if (res.isConfirmed) {
									getGameById(group?.game).then((res) => {
										if (
											res.status === 200 &&
											res.data?.active
										) {
											handleStartGame();
											navigate(
												ROUTES.TRANSITION_SCENARIOS,
												{
													state: {
														activeScenario: 1,
													},
												}
											);
										} else {
											modalWait({
												html: `<div class="d-flex flex-column">
														<div class="txt-turquoise txt18 bold">El juego aún no ha empezado.</div>
														<div class="mt-2 txt-turquoise txt18">
															Espera a que el moderador dé la orden.
														</div>
													</div>`,
											});
										}
									});
								}
							});
						}}
					>
						<div className="text-btn-main">AVANZAR</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default injectIntl(Context);
